import { render, staticRenderFns } from "./salesReceivingHistory.vue?vue&type=template&id=74720ac3&scoped=true"
import script from "./salesReceivingHistory.vue?vue&type=script&lang=js"
export * from "./salesReceivingHistory.vue?vue&type=script&lang=js"
import style0 from "./salesReceivingHistory.vue?vue&type=style&index=0&id=74720ac3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74720ac3",
  null
  
)

export default component.exports